"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForbiddenStatsAccessError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Throw when user is unauthorised to access endpoint
 */
class ForbiddenStatsAccessError extends client_library_1.ExtendableError {
    constructor() {
        super('You do not have access to this stats data');
    }
}
exports.ForbiddenStatsAccessError = ForbiddenStatsAccessError;
//# sourceMappingURL=ForbiddenStatsAccessError.js.map